import Config from '../../../config';
class EndpointsGetter {
    static getAggTypesEndpoint() {
        return Config.apiUrl + '/api/v1/aggregationTypes';
    }

    static getTimeBucketsEndpoint() {
        return Config.apiUrl + '/api/v1/timeBuckets';
    }

    static getAccountDetailsEndpoint() {
        return Config.apiUrl + '/api/v1/account';
    }

    static getDataGroupEndpoint() {
        return Config.apiUrl + '/api/v1/datagroups';
    }

    static getTimezonesEndpoint() {
        return Config.apiUrl + '/api/v1/timeZones/GMT';
    }

    static getAllGroupsEndpoint() {
        return Config.apiUrl + '/api/v1/datagroups/list';
    }

    static getAuthEndpoint() {
        return Config.apiUrl + '/api/v1/public/oauth/token';
    }

    static getWeekNumberEndpoint() {
        return Config.apiUrl + '/api/v1/weekNumber';
    }

    static getVerifyResetPasswordEndpoint() {
        return Config.apiUrl + '/api/v1/public/verify-reset-password-request';
    }

    static getResetPasswordEndpoint() {
        return Config.apiUrl + '/api/v1/public/reset-password';
    }

    static getSendMailForgotPasswordEndpoint() {
        return Config.apiUrl + '/api/v1/public/forgot-password';
    }

    static getRevokeTokenEndPoint() {
        return Config.apiUrl + '/api/v1/oauth/token/revoke/';
    }

    static getGoogleLoginEndpoint() {
        return `${Config.apiUrl}/api/v1/public/googleLogin`;
    }

    static getMicrosoftLoginEndpoint() {
        return `${Config.apiUrl}/api/v1/public/msLogin`;
    }

    static getUserData() {
        return `${Config.apiUrl}/api/v1/users/user`;
    }

    static getInviteUserEndpoint() {
        return `${Config.apiUrl}/api/v1/admin/invitation`;
    }

    static getUsersEndpoint() {
        return `${Config.apiUrl}/api/v1/users/list`;
    }

    static getDataGroupReplayStatsEndpoint() {
        return `${Config.apiUrl}/api/v1/datagroups/replaystats`;
    }

    static getUserByIdEndpoint() {
        return `${Config.apiUrl}/api/v1/users`;
    }

    static getUserUpdateByIdEndpoint() {
        return `${Config.apiUrl}/api/v1/users`;
    }

    static getChangeUserStatusEndpoint() {
        return `${Config.apiUrl}/api/v1/users/change`;
    }

    static getVerifyNewUserTokenEndpoint() {
        return `${Config.apiUrl}/api/v1/public/verify-new-user-token`;
    }

    static getSetNewPasswordEndpoint() {
        return `${Config.apiUrl}/api/v1/public/set-password`;
    }

    static getResendInvitationEndpoint() {
        return `${Config.apiUrl}/api/v1/admin/invitation/resend`;
    }

    static getUserAccountsEndpoint() {
        return `${Config.apiUrl}/api/v1/users/user/accounts`;
    }

    static setUserAccountEndpoint() {
        return `${Config.apiUrl}/api/v1/users/user/setAccount`;
    }

    static getDrillDownData() {
        return `${Config.apiUrl}/api/v1/datagroups/drilldown`;
    }

    static getDrillDownExportEndpoint() {
        return `${Config.apiUrl}/api/v1/datagroups/drilldown/export`;
    }
}

export default EndpointsGetter;





// WEBPACK FOOTER //
// ./src/main/content/common/EndpointsGetter.js